import { openModal } from '@members/modal/redux';
import type { Source } from '@members/stacks/analytics';

export const NOTIFICATIONS_MODAL_NAME = 'notificationsFromNav';
export const openNotificationsFromNav = (source: Source) =>
  openModal(NOTIFICATIONS_MODAL_NAME, source);
